// Home.js

import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Home.css";
import studentImg from "../../assets/images/pngwing/interview.png";

function Home() {
  const navigator = useNavigate();

  const handleRedirectUrl = (ulr) => {
    navigator(ulr);
  };

  return (
    <div className="landing-page min-h-screen flex flex-col justify-between text-lavender p-10">

      <header className="flex  items-center justify-center text-center py-16">
        <section className="w-auto max-w-[50%] flex justify-center flex-col items-center">
          <h1 className="landing-heading font-sans  font-bold mb-8">
            Welcome to Interview Questions Revision
          </h1>
          <p className="text-lg md:text-xl text-center  mb-4">
            Free resources to help you prepare for interviews
          </p>
          <Link
            to="/categories"
            className="getStartedBtn firstBtn bg-white text-gray-900 py-3 px-8 rounded-full font-bold text-lg hover:bg-blue-200 transition duration-300"
          >
            Get Started
          </Link>
        </section>

        <section className="w-[30%]">
          <img src={studentImg} alt="" className="student-img w-[80%] max-h-[70vh] " />
        </section>
      </header>

      <main className="container mx-auto py-12 bg-gray-800/40 backdrop-blur-sm px-5 rounded-md">
        <section className="mb-12">
          <h2 className="text-2xl md:text-3xl font-bold mb-4">
            Popular Categories
          </h2>
          <ul className="popularCategories grid grid-cols-1 md:grid-cols-3 gap-4">
            <li
              className="cursor-html bg-gray-900 cursor-pointer hover:bg-gray-950 p-4 rounded-lg text-center text-lavender"
              onClick={() => handleRedirectUrl("/categories/html")}
            >
              HTML
            </li>
            <li
              className="cursor-css bg-gray-900 cursor-pointer hover:bg-gray-950 p-4 rounded-lg text-center text-lavender"
              onClick={() => handleRedirectUrl("/categories/css")}
            >
              CSS
            </li>
            <li
              className="cursor-js bg-gray-900 cursor-pointer hover:bg-gray-950 p-4 rounded-lg text-center text-lavender"
              onClick={() => handleRedirectUrl("/categories/javascript")}
            >
              JavaScript
            </li>
          </ul>
        </section>
        <section className="mb-12">
          <h2 className="text-2xl md:text-3xl font-bold mb-4">
            Featured Questions
          </h2>
          <ul className="featuredQuestions grid grid-cols-1 md:grid-cols-2 gap-4">
            <li className="bg-gray-900 p-4 rounded-lg text-whtie">
              What is a closure in JavaScript?
            </li>
            <li className="bg-gray-900 p-4 rounded-lg text-whtie">
              Explain the box model in CSS
            </li>
            {/* Add more featured questions */}
          </ul>
        </section>
        <section>
          <h2 className="text-2xl md:text-3xl font-bold mb-4">Explore More</h2>
          <p className="text-lg md:text-xl mb-8 max-w-md">
            Explore our vast collection of interview questions
          </p>
          <Link
            to="/categories"
            className="getStartedBtn bg-white text-gray-900 py-3 px-8 rounded-full font-bold text-lg hover:bg-blue-200 transition duration-300"
          >
            Get Started
          </Link>
        </section>
      </main>
    </div>
  );
}

export default Home;
